import { c as _c } from "react-compiler-runtime";
import React from 'react';
import useGetFullWishlist from '@nike/shop-apis/buy/wishlists/v2/query-hooks/use-get-full-wishlist';
import ItemPriceBase from "../base/ItemPriceBase";
import useItemAddedModalStore from "../../../store/item-added-modal/use-store";

/**
 * Wishlist price component that uses price data directly from the wishlist cache.
 * Wishlist items include currentPrice, initialPrice, and employeePrice.
 */
var WishlistItemPrice = function WishlistItemPrice() {
  var $ = _c(11);
  var itemId_0 = useItemAddedModalStore(_temp);
  var t0;
  if ($[0] !== itemId_0) {
    t0 = {
      select: function select(t1) {
        var pages = t1.pages;
        var item_0 = pages === null || pages === void 0 ? void 0 : pages.find(function (item) {
          return item.id === itemId_0;
        });
        return item_0 ? {
          currentPrice: item_0.currentPrice,
          initialPrice: item_0.initialPrice,
          employeePrice: item_0.employeePrice,
          currency: item_0.currency
        } : null;
      }
    };
    $[0] = itemId_0;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  var _useGetFullWishlist = useGetFullWishlist(t0),
    priceData = _useGetFullWishlist.data,
    isLoading = _useGetFullWishlist.isLoading;
  var t1;
  if ($[2] !== (priceData === null || priceData === void 0 ? void 0 : priceData.currency)) {
    t1 = (priceData === null || priceData === void 0 ? void 0 : priceData.currency) || window.NikeShop.get().currency;
    $[2] = priceData === null || priceData === void 0 ? void 0 : priceData.currency;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  var currency = t1;
  var fullPrice = priceData === null || priceData === void 0 ? void 0 : priceData.initialPrice;
  var price = priceData === null || priceData === void 0 ? void 0 : priceData.currentPrice;
  var employeePrice = priceData === null || priceData === void 0 ? void 0 : priceData.employeePrice;
  var discount = fullPrice && price && price < fullPrice;
  var t2;
  if ($[4] !== currency || $[5] !== discount || $[6] !== employeePrice || $[7] !== fullPrice || $[8] !== isLoading || $[9] !== price) {
    t2 = /*#__PURE__*/React.createElement(ItemPriceBase, {
      currency: currency,
      fullPrice: fullPrice,
      price: price,
      employeePrice: employeePrice,
      discount: discount,
      isLoading: isLoading
    });
    $[4] = currency;
    $[5] = discount;
    $[6] = employeePrice;
    $[7] = fullPrice;
    $[8] = isLoading;
    $[9] = price;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export default WishlistItemPrice;
function _temp(t0) {
  var itemId = t0.itemId;
  return itemId;
}